import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import Navbar from "./home/components/Navbar"; // Yolun doğruluğunu kontrol et (../ olabilir)
import ProductCard from "@/components/ProductCard";

export default function Favorites() {
  const [favorites, setFavorites] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // Favorileri çekme fonksiyonu
  const fetchFavorites = async () => {
    try {
      setLoading(true);
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) return;

      const { data, error } = await supabase
        .from("user_favorites")
        .select("*, products(*)")
        .eq("user_id", user.id);

      if (error) throw error;
      setFavorites(data || []);
    } catch (err) {
      console.error("Favori çekme hatası:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFavorites();
    // Navbar sayaçlarını güncellemek için dinleyici
    window.addEventListener("navbar-update", fetchFavorites);
    return () => window.removeEventListener("navbar-update", fetchFavorites);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 1. ÜST MENÜ: isScrolled={true} ile beyaz zeminli Navbar gelir */}
      <Navbar isScrolled={true} />

      {/* 2. İÇERİK: pt-32 Navbar'ın altında kalmasını engeller */}
      <main className="max-w-7xl mx-auto px-4 pt-32 pb-20">
        <div className="flex justify-between items-center mb-12 border-b border-gray-100 pb-6">
          <h1 className="text-3xl font-black italic uppercase text-gray-900 tracking-tighter">
            FAVORİLERİM
          </h1>
          <span className="bg-rose-600 text-white px-5 py-1.5 rounded-full text-xs font-bold shadow-lg">
            {favorites.length} Ürün Listeleniyor
          </span>
        </div>

        {loading ? (
          <div className="flex flex-col items-center justify-center py-20 gap-4">
            <div className="w-10 h-10 border-4 border-rose-500 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-400 font-bold italic">YÜKLENİYOR...</p>
          </div>
        ) : favorites.length === 0 ? (
          <div className="text-center py-32 bg-white rounded-[40px] border border-gray-100 shadow-sm">
            <i className="ri-heart-line text-6xl text-gray-200 mb-4 block"></i>
            <p className="text-gray-500 font-bold text-xl italic">
              Henüz favori ürününüz yok.
            </p>
            <Link
              to="/"
              className="text-rose-600 underline font-bold mt-4 inline-block"
            >
              Alışverişe Başla
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {favorites.map((item) => (
              <ProductCard
                key={item.id}
                product={item.products}
                initialIsFavorite={true}
              />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
